<script lang="ts" setup>
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();

function logout() {
  authStore.logout();
}
</script>

<template>
  <v-container class="login">
    <v-row>
      <v-col md="2" sm="4"> </v-col>
      <v-col md="3" sm="6">
        <br /><br /><br />
        <div class="logo">
          <v-img alt="INNAX Logo" src="@/assets/img/logo.png" class="image" />
        </div>
        <br /><br /><br />
      </v-col>
    </v-row>

    <v-row>
      <v-col md="2" sm="4"> </v-col>
      <v-col md="6" sm="12">
        <h1>U bent geauthoriseerd voor de Paris Proof Monitor maar u bent nog niet gekoppeld aan een project of de geldigheid voor het project is verlopen.</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="2" sm="4"> </v-col>
      <v-col md="6" sm="12">
        <h2>Neem contact op met de administrator of beheerder van uw project(en)</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="2" sm="4"> </v-col>
      <v-col md="6" sm="12">
        <v-btn color="primary" @click="logout">Afmelden</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
